'use client';
import NotFoundContainer from './_components/Errors/NotFoundContainer';

export default function NotFound() {
    return <NotFoundContainer />;
}
